import { makeAutoObservable } from 'mobx';

import type { Range } from '@tiptap/core';

/**
 * MobX store managing editor state for slash commands and cursor persistence.
 */
class EditorStore {
  query = '';
  range: Range | null = null;
  activeEditorIds = new Set<string>();
  cursorPositions: Record<string, { from: number; to: number }> = {};

  constructor() {
    makeAutoObservable(this);
  }

  setQuery(value: string) {
    this.query = value;
  }

  setRange(value: Range | null) {
    this.range = value;
  }

  registerEditor(editorId: string) {
    this.activeEditorIds.add(editorId);
  }

  unregisterEditor(editorId: string) {
    this.activeEditorIds.delete(editorId);
  }

  isEditorActive(editorId: string) {
    return this.activeEditorIds.has(editorId);
  }

  setCursorPosition(editorId: string, position: { from: number; to: number }) {
    this.cursorPositions[editorId] = position;
  }

  resetQuery() {
    this.query = '';
  }

  resetRange() {
    this.range = null;
  }

  get hasActiveCommand(): boolean {
    return this.query.length > 0 && this.range !== null;
  }
}

export const editorStore = new EditorStore();
